export default __webpack_public_path__ + "static/media/owner.5c27c9e3.png";